import React, { useContext } from 'react'
import { FileContext } from '../../../Context'
import UploadedItem from './Item'
import useStyles from './Style'

const Uploaded: React.FC = () => {
  const classes = useStyles()
  const { Uppy } = useContext(FileContext)
  const Files = Uppy?.formatedFiles

  if (!Uppy || !Files) {
    return <></>
  }

  const formatedFilesToArray = Object.keys(Files)
  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        {formatedFilesToArray &&
          formatedFilesToArray.map((fileKey) => (
            <UploadedItem key={fileKey} file={Files[fileKey]} />
          ))}
      </div>
    </div>
  )
}

export default Uploaded
